import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { FC } from "react";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../lib/src/components/Loading";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export const DeleteMailAliasModal: FC<{ domain: MailDomain, aliasId: number, aliasAddress: string }> = ({ domain, aliasId, aliasAddress }) => {
  const { partnerClient } = useApiClient(config)
  const reload = useRefresh()
  const navigate = useNavigate()

  const confirm = async () => {
    if (domain === null) return
    await partnerClient.deleteAliasFromMailDomain(domain.id, aliasId)
    reload()
    navigate(`/mail/${domain.id}`)
  }
  return <Loading loading={aliasId === null}>
    <p className={""}>
      <strong>Caution!</strong> You are about to delete the alias <strong>{aliasAddress}</strong> from your domain.
    </p>
    <ModalFooter icon={faTrash} text={"Delete"} onSubmit={confirm} />
  </Loading>
}
